/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Box, Divider, Flex, Text, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { appApi } from '../../../../services/appApi'
import {
  Container,
  HeaderContainer
} from './styles'
import { MultiplaEscolha } from './components/MultiplaEscolha'
import { CaixaDeSelecao } from './components/CaixaDeSelecao'
import { Discursiva } from './components/Discursiva'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { FormatarMensagemEditorDeTexto, PropInvalida, useQuery } from '../../../../Utils/Helper'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { Body } from '../../../Layouts/Body'
import { Escala } from './components/Escala'
import { iNomeId } from '../../../../interfaces'
import { ENPS } from './components/eNPS'

type LocationProps = {
  paramId: string
}

interface iFormResponse {
  nomePesquisa: string
  feedbackId?: string
  empresaId?: string
  pesquisaId?: string
  participanteId?: string
  colaboradorId?: string
  txtEncerramento?: string
  linkRedirect?: string
  pesquisaPontosPositivos?: boolean
  questoes: iFormQuestaoResponse[]
}

interface iFormQuestaoResponse {
  id: string
  tipo: number
  enunciado: string
  obrigatoria: boolean
  alternativas?: iFormAlternativaResponse[]
  minCaixaSelecao?: number
  maxCaixaSelecao?: number
}

interface iFormAlternativaResponse {
  id: string
  texto: string
  peso?: number
}

interface iResposta {
  questaoId: string
  alternativaId: string
}

interface iRespostaExtra {
  questaoId: string
  alternativasExtra: string[]
}

interface iRespostaDiscursiva {
  questaoId: string
  texto: string
}

interface iRespostaeNPS {
  questaoId: string
  valor: string
}

interface iRespostaRequest {
  questaoId: string
  tipo: number
  alternativasId?: string[]
  texto?: string
  extras?: string[]
}

export const PreenchimentoPesquisaInterna: React.FC = () => {
  const nav = useNavigate()
  const param = useParams<LocationProps>()
  const toast = useToast()
  const query = useQuery()
  const { pathname, search } = useLocation()
  const [Model, setModel] = useState<iFormResponse>()
  const [RespostasObjetiva, setRespostasObjetiva] = useState<iResposta[]>([])
  const [RespostasCaixaSelecao, setRespostasCaixaSelecao] = useState<iResposta[]>([])
  const [RespostasCaixaSelecaoExtra, setRespostasCaixaSelecaoExtra] = useState<iRespostaExtra[]>([])
  const [RespostasDiscursivas, setRespostasDiscursivas] = useState<iRespostaDiscursiva[]>([])
  const [RespostaseNPS, setRespostaseNPS] = useState<iRespostaeNPS[]>([])
  const [Erros, setErros] = useState<string[]>([])
  const [OutrasPesquisas, setOutrasPesquisas] = useState<iNomeId[]>([])
  const [TimeoutId, setTimeoutId] = useState<NodeJS.Timeout>()
  const [Respondido, setRespondido] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)

  function getFormulario(): void {
    if (pathname.includes('Formulario') && pathname.includes('Previsualizar')) {
      appApi.get(`PesquisaInterna/Formulario/${param.paramId as string}/Previsualizar`)
        .then(resp => setModel(resp.data)).catch(err => console.log(err))
    } else if (pathname.includes('Jornada/PesquisaInterna/Gestao') && pathname.includes('Previsualizar')) {
      appApi.get(`PesquisaInterna/${param.paramId as string}/Previsualizar`)
        .then(resp => setModel(resp.data)).catch(err => console.log(err))
    } else {
      appApi.get(`PesquisaInterna/${param.paramId as string}/Preenchimento`)
        .then(resp => {
          const data: iFormResponse = resp.data
          setModel(data)
          if (data.feedbackId && data.colaboradorId && data.empresaId && data.pesquisaId && data.participanteId) {
            appApi.get(`FeedbackPersonalizado/${data.feedbackId}/Participante/${data.colaboradorId}/PesquisasPendentes?pesquisaId=${data.pesquisaId}&empresaId=${data.empresaId}&participanteId=${data.participanteId}`)
              .then((resFeedback) => {
                const feedbackData: iNomeId[] | null | undefined = resFeedback.data
                if (feedbackData && feedbackData.length > 0) {
                  setOutrasPesquisas(feedbackData)
                }
              })
              .catch((err) => console.log(err))
          }
        }).catch(err => console.log(err))
    }
  }

  function SelRespostaObjetiva(questaoId: string, alternativaId: string): void {
    if (!isSelectQuestao(questaoId)) {
      setRespostasObjetiva(oldArray => [...oldArray, { questaoId: questaoId, alternativaId: alternativaId }])
    } else {
      if (!isSelect(questaoId, alternativaId)) {
        UpdateRespostaObjetiva(questaoId, alternativaId)
      }
    }
  }

  function UpdateRespostaObjetiva(questaoId: string, alternativaId: string): void {
    const respostas = [...RespostasObjetiva]
    const pos = respostas.findIndex(e => e.questaoId === questaoId)
    if (pos !== -1) {
      respostas[pos].alternativaId = alternativaId
      setRespostasObjetiva(respostas)
    }
  }

  const isSelect = (perguntaId: string, alternativaId: string): boolean => RespostasObjetiva.find(e => e.questaoId === perguntaId && e.alternativaId === alternativaId) !== undefined
  const isSelectQuestao = (perguntaId: string): boolean => RespostasObjetiva.find(e => e.questaoId === perguntaId) !== undefined

  const hasError = (perguntaId: string): boolean => Erros.find(e => e === perguntaId) !== undefined

  function SelecionarMultiplaEscolhaExtras(questaoId: string, lista: string[]): void {
    if (RespostasCaixaSelecaoExtra.find(r => r.questaoId === questaoId) === undefined) {
      setRespostasCaixaSelecaoExtra(oldArray => [...oldArray, { questaoId: questaoId, alternativasExtra: lista }])
    } else {
      const copy = [...RespostasCaixaSelecaoExtra]
      const index = copy.findIndex(e => e.questaoId === questaoId)
      copy[index] = { alternativasExtra: lista, questaoId: questaoId }
      setRespostasCaixaSelecaoExtra(copy)
    }
  }

  function SelecionarMultiplaEscolha(questaoId: string, alternativaId: string): void {
    if (RespostasCaixaSelecao.find(r => r.questaoId === questaoId && r.alternativaId === alternativaId) === undefined) {
      setRespostasCaixaSelecao(oldArray => [...oldArray, { questaoId: questaoId, alternativaId: alternativaId }])
    } else {
      const copy = [...RespostasCaixaSelecao].filter(e => e.alternativaId !== alternativaId)
      setRespostasCaixaSelecao(copy)
    }
  }

  function UpdateDiscursiva(id: string, upTexto: string): void {
    const pos = RespostasDiscursivas.findIndex(e => e.questaoId === id)
    if (pos !== -1) {
      const copy = [...RespostasDiscursivas]
      copy[pos].texto = upTexto
      setRespostasDiscursivas(copy)
    } else {
      setRespostasDiscursivas(oldArray => [...oldArray,
        {
          questaoId: id, texto: upTexto
        }])
    }
  }

  function isENPSValue(texto: string): boolean {
    const t = texto.trim()
    if (t === '') return false
    const n = Number(t)
    return Number.isInteger(n) && n >= 0 && n <= 10
  }

  function UpdateeNPS(id: string, Valor: string): void {
    const pos = RespostaseNPS.findIndex(e => e.questaoId === id)

    if (pos !== -1) {
      const copy = [...RespostaseNPS]
      copy[pos].valor = Valor
      setRespostaseNPS(copy)
    } else {
      setRespostaseNPS(oldArray => [...oldArray,
        {
          questaoId: id, valor: Valor
        }])
    }
  }

  function ValidarTodasRespostas(): boolean {
    const naoRespondidas = Model?.questoes
      .filter(r => r.obrigatoria)
      .map((e) => {
        const disc = RespostasDiscursivas?.find(r => r.questaoId === e.id)?.texto ?? ''
        const respondeuDisc = disc.trim().length >= 3 || isENPSValue(disc)

        const enps = RespostaseNPS?.find(r => r.questaoId === e.id)?.valor ?? ''
        const respondeuENPS = isENPSValue(enps) // ou: enps.trim() !== ''
        if (
          RespostasObjetiva.find(r => r.questaoId === e.id) === undefined &&
          RespostasCaixaSelecao.find(r => r.questaoId === e.id) === undefined &&
          RespostasCaixaSelecaoExtra.find(r => r.questaoId === e.id && r.alternativasExtra.length > 0) === undefined &&
          !respondeuDisc &&
          !respondeuENPS
        ) {
          return e.id
        }
        return null
      })
    const filtrado = naoRespondidas?.filter(e => e !== null)
    if (filtrado !== null && filtrado !== undefined && filtrado?.length > 0) {
      setErros(filtrado as string[])
      toast({
        title: 'Alguns campos não foram preenchidos, revise o formulário e veja se possui campos em vermelho',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return false
    }

    const CaixaSelecaoInvalidas = Model?.questoes.filter(r => (r.obrigatoria || RespostasCaixaSelecao.some(e => e.questaoId === r.id)) && !PropInvalida(r.maxCaixaSelecao))
      .map((e) => {
        let respostas = RespostasCaixaSelecao.filter(r => r.questaoId === e.id).length
        if (RespostasCaixaSelecaoExtra.some(a => a.questaoId === e.id)) {
          respostas += (RespostasCaixaSelecaoExtra.find(a => a.questaoId === e.id)?.alternativasExtra.length ?? 0)
        }
        if (!(respostas >= (e.minCaixaSelecao ?? 0) && respostas <= (e.maxCaixaSelecao ?? 0))) {
          return e.id
        }
        return null
      })

    if (CaixaSelecaoInvalidas !== null && CaixaSelecaoInvalidas !== undefined && CaixaSelecaoInvalidas?.filter(r => r !== null).length > 0) {
      setErros(CaixaSelecaoInvalidas?.filter(e => e !== null) as string[])
      toast({
        title: 'Alguns campos não foram preenchidos, revise o formulário e veja se possui campos em vermelho',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return false
    }

    return true
  }

  function Redirect(): void {
    if (query.get('quiosque')) {
      nav(`${pathname.replace('Preenchimento', 'Abertura')}${search}`)
      return
    } else if (Model?.pesquisaPontosPositivos) {
      nav('/')
      return
    }
    window.location.href = Model?.linkRedirect as string
  }

  function EnviarResposta(): void {
    if (ValidarTodasRespostas()) {
      const respostas: iRespostaRequest[] = []
      RespostasObjetiva.forEach((e) => {
        respostas.push({
          tipo: 0,
          questaoId: e.questaoId,
          alternativasId: [e.alternativaId]
        })
      })

      Model?.questoes.filter(r => r.tipo === 1).forEach((e) => {
        const resposta = RespostasDiscursivas?.find(t => t.questaoId === e.id)
        respostas.push({
          questaoId: e.id,
          tipo: 1,
          texto: resposta?.texto ?? ''
        } as iRespostaRequest)
      })

      Model?.questoes.filter(r => r.tipo === 4).forEach((e) => {
        const resposta = RespostaseNPS?.find(t => t.questaoId === e.id)
        respostas.push({
          questaoId: e.id,
          tipo: 4,
          texto: resposta?.valor ?? ''
        } as iRespostaRequest)
      })

      Model?.questoes.filter(e => e.tipo === 5).forEach((e) => {
        respostas.push({
          questaoId: e.id,
          tipo: 5,
          alternativasId: RespostasCaixaSelecao.filter(r => r.questaoId === e.id).map((r) => {
            return r.alternativaId
          }),
          extras: RespostasCaixaSelecaoExtra.find(a => a.questaoId === e.id)?.alternativasExtra
        })
      })
      setIsLoading(true)
      appApi.post(`PesquisaInterna/${param.paramId as string}/Responder`, respostas)
        .then(() => {
          setRespondido(true)
          if ((!OutrasPesquisas || OutrasPesquisas.length === 0) && Model?.linkRedirect !== undefined && Model?.linkRedirect !== null) {
            const timeoutId = setTimeout(() => { Redirect() }, 5000)
            setTimeoutId(timeoutId)
          }
        })
        .catch(err => console.log(err))
        .finally(() => setIsLoading(false))
    }
  }

  function ClicarVoltar(): void {
    if (query.get('quiosque')) {
      nav(`${pathname.replace('Preenchimento', 'Abertura')}${search}`)
      clearTimeout(Number(TimeoutId))
    } else {
      nav('/')
    }
  }

  useEffect(() => {
    getFormulario()
  }, [])

  return (
    <Body>
      <WhiteContainer padding='0'>
        <HeaderContainer>
          <h1>{Model?.nomePesquisa}</h1>
          <img alt='Logo da empresa' src='https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png' />
        </HeaderContainer>
        <Box bg='var(--DegradeAzul)' className={'gradient-blue'} h={'3px'} w={'full'}></Box>
        {
          (!Respondido) && (
            <Container>
              {
                Model?.questoes?.map((e: iFormQuestaoResponse, i) => {
                  if (e.tipo === 0) {
                    return (
                      <MultiplaEscolha
                        key={i}
                        questao={e}
                        isSelect={isSelect}
                        SelecionarQuestao={SelRespostaObjetiva}
                        erro={hasError(e.id)}
                      />
                    )
                  } else if (e.tipo === 5) {
                    return (
                      <CaixaDeSelecao
                        key={i}
                        selecionadas={RespostasCaixaSelecao.filter(f => f.questaoId === e.id).length}
                        questao={e}
                        pesquisaPontosPositivo={Model.pesquisaPontosPositivos}
                        onAddExtras={SelecionarMultiplaEscolhaExtras}
                        Selecionar={SelecionarMultiplaEscolha}
                        erro={hasError(e.id)}
                      />
                    )
                  } else if (e.tipo === 1) {
                    return (
                      <Discursiva
                        key={e.id}
                        questao={e}
                        erro={hasError(e.id)}
                        UpdateText={UpdateDiscursiva}
                      />
                    )
                  } else if (e.tipo === 6) {
                    return (
                      <Escala
                        key={i}
                        questao={e}
                        isSelect={isSelect}
                        SelecionarQuestao={SelRespostaObjetiva}
                        erro={hasError(e.id)}
                      />
                    )
                  } else if (e.tipo === 4) {
                    return (
                      <ENPS
                        key={i}
                        questao={e}
                        updateValor={UpdateeNPS}
                        erro={hasError(e.id)}
                      />
                    )
                  }
                  return null
                })
              }

              {pathname.includes('Previsualizar')
                ? <Flex justifyContent={'end'} margin={'2rem 0 1rem 0rem'}>
                <ButtonCmp onClick={() => nav(-1)} w={'8rem'} VarColor={'c6'}>Voltar</ButtonCmp>
              </Flex>
                : <Flex justifyContent={'center'} margin={'2rem 0 1rem 0rem'}>
                <ButtonCmp onClick={EnviarResposta} w={'15rem'} VarColor='Green2' isLoading={IsLoading}>Enviar resposta</ButtonCmp>
              </Flex>}
            </Container>
          )
        }

        {
          (Respondido) && (
            <Flex background={'white'} height={'100%'} w={'100%'}>
              <Flex padding={'3rem 3rem'} flexDirection={'column'} w={'100%'}>
                <h3 dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(Model?.txtEncerramento ?? 'Obrigado pela participação!') }}></h3>
                <Text fontWeight={'400'} style={{ color: 'var(--c6)', marginTop: '1rem' }}>Respostas enviadas com sucesso!</Text>
                {
                  (localStorage.getItem('token')) && (
                    <Flex marginTop={'1rem'}>
                      <ButtonCmp
                        VarColor='c6'
                        size={'lg'}
                        onClick={ClicarVoltar}
                      >Voltar</ButtonCmp>
                    </Flex>
                  )
                }
                {OutrasPesquisas.length > 0 && <Flex flexDir={'column'} gap={'1rem'} mt={'2rem'} w={'100%'}>
                  <Divider borderColor={'var(--Azul)'} opacity={'.8'}/>
                  <Text fontSize={'16px'} fontWeight={700}>Outros itens pendentes para responder</Text>
                  <Flex gap={'1rem'}>
                    {OutrasPesquisas.map(e => {
                      return <Flex border={'1px solid var(--Gray2)'} bg={'var(--AzulOpacoBg)'} p={'.5rem 1rem'} flexDir='column' alignItems={'center'} gap={'.75rem'} borderRadius={'.325rem'}>
                        <Flex flexDir={'column'} alignItems={'center'}>
                          <Text fontSize={'16px'} fontWeight={600}>{e.nome}</Text>
                          <Text fontSize={'14px'} fontWeight={400}>{e.avatar}</Text>
                        </Flex>
                        <ButtonCmp onClick={() => { window.location.href = e.complemento ?? '' }} VarColor='Green2'>Responder</ButtonCmp>
                      </Flex>
                    })}
                  </Flex>
                </Flex>}
              </Flex>
            </Flex>
          )
        }

      </WhiteContainer>
    </Body>
  )
}
